module.exports = __webpack_public_path__ + "static/media/object.1ec02b9a.gif";